var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 707,
    viewBox: "0 0 788 707",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.67 659.238C317.874 670.034 317.874 687.815 328.67 698.611C334.385 704.326 341.371 706.867 348.356 706.867C355.342 706.867 362.327 704.326 368.043 698.611L730.019 336.634C806.86 259.794 806.86 134.69 730.019 58.484C681.121 9.5854 612.536 -8.1959 549.031 5.14008C513.468 12.7606 479.176 30.5419 451.869 58.484L8.60619 501.747C3.52582 506.827 0.350586 513.812 0.350586 521.433C0.350586 529.054 3.52582 536.039 8.60619 541.119L166.098 698.611C176.894 709.407 194.675 709.407 205.471 698.611L608.09 295.991C618.886 285.196 618.886 267.414 608.09 256.619L529.344 177.873C524.264 172.792 517.279 169.617 509.658 169.617C502.037 169.617 495.052 172.792 489.972 177.873L168.638 499.206C157.842 510.002 157.842 527.783 168.638 538.579C179.434 549.375 197.215 549.375 208.011 538.579L509.658 236.932L549.031 276.305L185.784 639.552L67.6655 521.433L491.242 97.8569C546.491 42.6078 636.032 42.6078 690.646 97.8569C745.895 153.106 745.895 242.648 690.646 297.262L328.67 659.238Z",
    fill: "#5D3587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.43f823fa9c0a7be30467d62991f1958c.svg";
export { ForwardRef as ReactComponent };